// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-list {
    width: 500px;
    max-width: 100%;
    border: solid 1px #ccc;
    min-height: 60px;
    display: block;
    background: white;
    border-radius: 4px;
    overflow: hidden;
    margin-left: 300px;
    margin-top: 50px;
}

.example-box {
  padding: 20px 10px;
  border-bottom: solid 1px #ccc;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 14px;
}

.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
              0 8px 10px 1px rgba(0, 0, 0, 0.14),
              0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.cdk-drag-placeholder {
  opacity: 0;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.example-box:last-child {
  border: none;
}

.example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.shadow {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.3);
  z-index: 10000;
}

.lift {
  z-index: 10001;
}

.select-compare--tip {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  max-height: 170px;
  left: 0;
  bottom: calc(-170px - 16px);
  padding: 24px;
  background-color: white;
  line-height: 1.5;
  border: 1px solid #D9D9D9;
  border-radius: 8px;
  box-shadow: 0 24px 32px 0 rgba(12, 0, 51, 0.1);
}

.select-compare--tip > button {
  margin-top: 24px;
}

.select-compare--arrow {
  position: absolute;
  width: 16px;
  height: 16px;
  background-color: white;
  top: -8px;
  transform: rotate(45deg);
  left: 44px;
  border-top: 1px solid #D9D9D9;
  border-left: 1px solid #D9D9D9;
  box-shadow: 0 24px 32px 0 rgba(12, 0, 51, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/app/uilib/sortable-checkbox-menu/sortable-checkbox-menu.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB;;gDAE8C;AAChD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,OAAO;EACP,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,UAAU;EACV,6BAA6B;EAC7B,8BAA8B;EAC9B,8CAA8C;AAChD","sourcesContent":[".example-list {\r\n    width: 500px;\r\n    max-width: 100%;\r\n    border: solid 1px #ccc;\r\n    min-height: 60px;\r\n    display: block;\r\n    background: white;\r\n    border-radius: 4px;\r\n    overflow: hidden;\r\n    margin-left: 300px;\r\n    margin-top: 50px;\r\n}\r\n\r\n.example-box {\r\n  padding: 20px 10px;\r\n  border-bottom: solid 1px #ccc;\r\n  color: rgba(0, 0, 0, 0.87);\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  box-sizing: border-box;\r\n  cursor: move;\r\n  background: white;\r\n  font-size: 14px;\r\n}\r\n\r\n.cdk-drag-preview {\r\n  box-sizing: border-box;\r\n  border-radius: 4px;\r\n  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\r\n              0 8px 10px 1px rgba(0, 0, 0, 0.14),\r\n              0 3px 14px 2px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.cdk-drag-placeholder {\r\n  opacity: 0;\r\n}\r\n\r\n.cdk-drag-animating {\r\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\r\n}\r\n\r\n.example-box:last-child {\r\n  border: none;\r\n}\r\n\r\n.example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {\r\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\r\n}\r\n\r\n.shadow {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-color: rgba(0,0,0,0.3);\r\n  z-index: 10000;\r\n}\r\n\r\n.lift {\r\n  z-index: 10001;\r\n}\r\n\r\n.select-compare--tip {\r\n  position: absolute;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  width: 100%;\r\n  max-height: 170px;\r\n  left: 0;\r\n  bottom: calc(-170px - 16px);\r\n  padding: 24px;\r\n  background-color: white;\r\n  line-height: 1.5;\r\n  border: 1px solid #D9D9D9;\r\n  border-radius: 8px;\r\n  box-shadow: 0 24px 32px 0 rgba(12, 0, 51, 0.1);\r\n}\r\n\r\n.select-compare--tip > button {\r\n  margin-top: 24px;\r\n}\r\n\r\n.select-compare--arrow {\r\n  position: absolute;\r\n  width: 16px;\r\n  height: 16px;\r\n  background-color: white;\r\n  top: -8px;\r\n  transform: rotate(45deg);\r\n  left: 44px;\r\n  border-top: 1px solid #D9D9D9;\r\n  border-left: 1px solid #D9D9D9;\r\n  box-shadow: 0 24px 32px 0 rgba(12, 0, 51, 0.1);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
